module.exports = __webpack_public_path__ + "img/call-ic.2d4b7d79.svg";